export default {
  unlinkIntegration(state, provider) {
    if ('email' in state[provider]) {
      state[provider].email = null;
    } else if ('valid' in state[provider]) {
      state[provider].valid = false;
    }
  },
};
